/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedResponse } from '../../models/paginated-response';

export interface EventsControllerFindInPreparation$Params {
  page?: number;
  limit?: number;

/**
 * Search in event name (SK or EN)
 */
  search?: string;

/**
 * Filter by tag IDs
 */
  tagIds?: Array<string>;

/**
 * Filter by active status
 */
  isActive?: boolean;

/**
 * Filter by private status
 */
  private?: boolean;
}

export function eventsControllerFindInPreparation(http: HttpClient, rootUrl: string, params?: EventsControllerFindInPreparation$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerFindInPreparation.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('tagIds', params.tagIds, {});
    rb.query('isActive', params.isActive, {});
    rb.query('private', params.private, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

eventsControllerFindInPreparation.PATH = '/events/in-preparation';
